var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInformationButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2490_2618)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8,
    fill: "#205368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37248 0 0 5.37267 0 12C0 18.6277 5.37248 24 12 24C18.6275 24 24 18.6277 24 12C24 5.37267 18.6275 0 12 0ZM12 6C12.8285 6 13.5 6.67163 13.5 7.5C13.5 8.32875 12.8285 9 12 9C11.1715 9 10.5 8.32875 10.5 7.5C10.5 6.67163 11.1715 6 12 6ZM14.25 18H9.75C9.33581 18 9 17.6646 9 17.25C9 16.8358 9.33581 16.5 9.75 16.5H10.5V12H9.75C9.33581 12 9 11.6646 9 11.25C9 10.8358 9.33581 10.5 9.75 10.5H12.75C13.1642 10.5 13.5 10.8358 13.5 11.25V16.5H14.25C14.6642 16.5 15 16.8358 15 17.25C15 17.6646 14.6642 18 14.25 18Z",
    fill: "#FFCF00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2490_2618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationButton);
export default __webpack_public_path__ + "static/media/information-button.38402ef00c117c8cd8e62011834a3801.svg";
export { ForwardRef as ReactComponent };